module.exports = __webpack_public_path__ + "media/images/icons/filled/ci-circle-f6a93032b3cc2c193cc6eb5b547e76d2.svg";